import { getTokens } from '@rsos/sinatra';
import { checkStatus, parseJSON } from '@rsos/utils';
import { getAPIHost } from '@rsos/utils/metaTags';

const baseURL = `${getAPIHost()}/v1/deeplink/eagleview/authentication`;

export const getObliqueImageryToken = ({ org = {} }) => {
  const token = getTokens().token;

  try {
    return fetch(`${baseURL}/${org.id}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      credentials: 'same-origin',
    })
      .then(checkStatus)
      .then(parseJSON)
      .then(res => res);
  } catch (error) {
    return error;
  }
};
